// extracted by mini-css-extract-plugin
export default {"heading":"Dv-z","corrected":"Ev-z","redirectVerbiageContainer":"Fv-z","redirectVerbiageText":"Gv-z"};